import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Route, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PARTNER_BUILD } from '../../../_helpers/configuration';

@Injectable({
    providedIn: 'root'
})
export class PartnerLoginGuard {

    constructor(private _router: Router) { }

    private getConsentIdFromUrl(url: string): string | null {
        try {
            const queryString = url.split('?')[1];
            if (!queryString) return null;
            const params = new URLSearchParams(queryString);
            return params.get('consent_id');
        } catch (e) {
            return null;
        }
    }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        // Check if it's a partner build and consent_id is missing
        if (PARTNER_BUILD) {
            const consentId = this.getConsentIdFromUrl(window.location.href);
            if (!consentId) {
                this._router.navigate(['/404']);
                return false;
            }
        }
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // Check if it's a partner build and consent_id is missing
        if (PARTNER_BUILD) {
            const consentId = this.getConsentIdFromUrl(state.url) || route.queryParams?.consent_id;
            if (!consentId) {
                this._router.navigate(['/404']);
                return false;
            }
        }
        return true;
    }
}
